import InputMUISearch from './InputMUISearch';

export default InputMUISearch;
